
export const _timingSlotClass = {
  displayName: { type: 'string', title: 'Osan julkaisunimi' },
  days: {
    type: "array",
    title: "Päivät",
    items: {
      type: "string",
      oneOf: [{ const: 1, title: 'Maanantai' }, { const: 2, title: 'Tiistai' }, { const: 3, title: 'Keskiviikko' }, { const: 4, title: 'Torstai' }, { const: 5, title: 'Perjantai' }, { const: 6, title: 'Lauantai' }, { const: 7, title: 'Sunnuntai' }]
    },
    "uniqueItems": true
  },
  starttime: {
    type: 'string',
    title: 'Alkuaika'
  },
  endtime: {
    type: 'string',
    title: 'Loppuaika'
  },
}

export const _timingSlotClassDeps = {
}

export const _timingSlotUISchema = {
  days: {
    'ui:widget':'checkboxes'
  },
  starttime: {
    'ui:widget':'timeWidget'
  },
  endtime: {
    'ui:widget':'timeWidget'
  }
}

export const _timingClass = {
  name: { type: 'string', title: 'Aikataulun nimi' },
  active: { type: 'boolean', title: 'Active' },
  validstart: { type: 'string', format: 'date', title: 'Alkupäivä' },
  validend: { type: 'string', format: 'date', title: 'Loppupäivä' },
}


export const _timingUISchema = {
}

